import ky from 'ky';
import { z } from 'zod';
import { ENV } from 'src/utils/env';

export interface ManageInternalUserFlagPromiseParams {
  action: 'RETRIEVE' | 'ADD' | 'DELETE';
  user_email: string;
}

const INTERNAL_USER_RESPONSE_SCHEMA = z.object({
  data: z.boolean(),
  error: z.string().nullable().optional(),
});

export const manageInternalUserFlagPromise = async (
  params: ManageInternalUserFlagPromiseParams,
  signal?: AbortSignal
) => {
  try {
    const res = await ky
      .post(`${ENV.FRONTEND_API_URL}/internal_user_management`, {
        body: JSON.stringify(params),
        signal: signal,
      })
      .json();

    const validatedRes = INTERNAL_USER_RESPONSE_SCHEMA.safeParse(res);

    if (!validatedRes.success) {
      return false;
    }

    return validatedRes.data.data;
  } catch (e) {
    console.error('manageInternalUserFlagPromise', e);

    return false;
  }
};
